<template>
  <div class="d-flex justify-space-between my-5">
    <div class="w-25 pr-5">
      <v-text-field
        label="Order Number"
        v-model="orderNumber"
        @change="$emit('update:orderNumber', $event)"
        dense
        solo
        append-icon="shopping_basket"
        hide-details
      >
      </v-text-field>
    </div>
   
    <div class="w-25 text-right">
      <v-btn class="px-2 w-100" color="primary" @click="$emit('apply')"
        >Apply filters</v-btn
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    orderNumber: {
      type: String,
      default: null
    },
    surgeryId: {
      type: String,
      default: null
    },
    paymentStatus: {
      type: String,
      default: null
    }
  },
  computed: {
    surgeries() {
      let surgeries = this.$store.state.surgeries.surgeries;
      surgeries.unshift({
        name: "All",
        id: null
      });
      return surgeries;
    }
  },
  async mounted() {
    await this.$store.dispatch("surgeries/LOAD_SURGERIES", {
      from: 0,
      to: 0
    });
  },
  data() {
    return {
      paymentStatuses: [
        {
          text: "All",
          value: null
        },
        {
          text: "Pending",
          value: "pending"
        },
        {
          text: "Processing",
          value: "processing"
        },
        {
          text: "Processed",
          value: "processed"
        },
        {
          text: "Payment Failed",
          value: "payment_failed"
        }
      ]
    };
  }
};
</script>
